import Dnd from '../../grid/dnd';

export default instance => {
  instance.attachEvent('onBeforeRowDragEnd', (id, newParentId, tindex) => Dnd.onBeforeRowDragEnd(id, newParentId, tindex));
};
